import React, { useState } from 'react'
// import './UserHome.css';
import { BreadCrumb } from "primereact/breadcrumb";
import { Sidebar } from "primereact/sidebar";
// import { Avatar } from "primereact/avatar";
import { Link } from 'react-router-dom';

function AdminHome() {
    const iconItemTemplate = (item: any, options: any) => {
        return (
            <Link to={''} className="header-link text-dsGray">
                <span className={item.icon}></span> { item.label }
            </Link>
        );
    };
    const customIcons = (
        <React.Fragment>
            {/* <Link to="/" style={{ textDecoration: 'none' }} className='flex flex-row w-full bg-white'>
                <div className='self-center pt-2 text-4xl py-0 font-bold text-dsBlue font-Roboto text-center flex items-center justify-center'>
                    <img src="assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                    <p className='p-0 m-0 uppercase'>Autoneg</p> 
                    <span className='font-Roboto self-end text-red-700 text-sm'>&nbsp;3.0</span>
                </div>
            </Link> */}
        </React.Fragment>
    );

    // const customHeader = (
    //     <div className="flex align-items-center gap-2">
    //         <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" />
    //         <span className="font-bold">Amy Elsner</span>
    //     </div>
    // );
    const items = [
        { label: 'Home', template: iconItemTemplate },
        { label: 'Link', template: iconItemTemplate }
    ];
    const home = { icon: 'pi pi-home', url: '/', color: 'red' };
    const [ visible, setVisible ] = useState(false);

    return (
        <div className='flex flex-col lg:flex-row lg:h-screen lg:overflow-y-hidden w-full min-w-[330px]'>
            <div className='lg:hidden bg-dsgray' style={{ paddingBottom: '15px' }}>
                <div className='bg-dsgray user-home-navbar-effects flex flex-col'>
                    <div className='absolute top-5'><i onClick={() => { setVisible(true); }} className="material-icons-outlined md-24 absolute left-5 ">menu</i></div>
                    {/* MOBILE */}
                    <a href={'/'} className='contents w-fit' style={{ textDecoration: 'none' }}>
                        <div className='self-center pt-2 text-4xl py-0 font-bold text-dsBlue font-Roboto text-center flex items-center justify-center'>
                            <img src="assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                            <p className='p-0 m-0 uppercase'>Autoneg</p> 
                            <span className='font-Roboto self-end text-red-700 text-sm'>&nbsp;3.0</span>
                        </div>
                    </a>
                    <div className='self-center text-xl py-0 font-bold text-green-800 font-Roboto text-center'>Facturacion <span className='text-text-green-800'>Electronica</span></div>
                    <div className='text-xl py-0 text-dsGray font-bold font-Roboto text-center'>Nombre de la compa&ntilde;ia del Cliente</div>
                </div>
            </div>
            {/* sidebar */}
            <div className='hidden lg:block w-2/12 xl:w-2/12 bg-dsdark user-home-navbar-effects text-white'>
                {/* logo */}
                {/* <div className='flex w-full justify-center p-4 text-center'>
                    <Link to={'/'}>
                        <img className='w-4/5 h-auto' src="assets/img/logobig.png" alt="" />
                    </Link>
                </div> */}
                <div className='bg-dsgray user-home-navbar-effects min-h-[56px] xl:min-h-[75px] xl:max-h-[75px]'>
                    <a href={'/'} className='' style={{ textDecoration: 'none' }}>
                        <div className=' pt-2 text-lg 2xl:text-4xl py-0 font-bold text-dsBlue font-Roboto w-full text-center flex items-center justify-center'>
                            <img src="assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                            <p className='p-0 m-0 uppercase'>Autoneg</p> 
                            <span className='font-Roboto self-end text-red-700 text-[8px] xl:text-sm'>&nbsp;3.0</span>
                        </div>
                        <div className=' text-md 2xl:text-xl py-0 font-bold text-green-800 font-Roboto w-full text-center'>Facturacion <span className='text-text-green-800'>Electronica</span></div>
                    </a>
                </div>
                {/* menu */}
                <div className='mt-8 px-3 xl:px-6 w-full '>
                    <div>
                        {/* grupo */}
                        <div className='font-bold mb-2 mt-2 flex items-center text-sm 2xl:text-base'>
                            Comprobantes
                        </div>
                        <div>
                            <ul className='mt-0 pl-0 space-y-3' style={{textDecoration: 'none', listStyle: 'none'}}>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">dashboard</i>&nbsp; Resumen</li>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">call_made</i>&nbsp; Emitidos</li>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">call_received</i> &nbsp; Recibidos</li>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">check</i> &nbsp; Aprobacion</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        {/* grupo */}
                        <div className='font-bold mb-2 flex items-center text-sm 2xl:text-base mt-12'>
                            Clientes
                        </div>
                        <div>
                            <ul className='mt-0 pl-0 space-y-2' style={{textDecoration: 'none', listStyle: 'none'}}>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">list</i>&nbsp; Listado</li>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">verified_user</i>&nbsp; Authorizar Rutas</li>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">forward_to_inbox</i>&nbsp; Enviar Uso</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        {/* grupo */}
                        <div className='font-bold mb-2 flex items-center text-sm 2xl:text-base mt-12'>
                            Usuario
                        </div>
                        <div>
                            <ul className='mt-0 pl-0 space-y-2' style={{textDecoration: 'none', listStyle: 'none'}}>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">person</i>&nbsp; Perfil</li>
                                <li className='flex items-center text-sm 2xl:text-base'><i className="material-icons-outlined md-18 ">manage_accounts</i>&nbsp; Configuracion</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* content */}
            <div className='w-full lg:w-10/12 xl:w-10/12 bg-dsgray overflow-y-auto'>
                <div className='w-full min-h-full flex flex-col'>
                    <div className='hidden px-8 xl:py-2 ds-container-bottom-shadow lg:flex sticky top-0 z-[990] bg-dsgray min-h-[56px] xl:min-h-[75px] xl:max-h-[75px] items-center'>
                        {/* <div className='text-4xl py-0 font-bold text-dsGray font-Roboto'>Facturacion <span className='text-dsGray'>Electronica</span></div> */}
                        <div className='w-8/12 flex flex-col space-y-1'>
                        <div className='text-md xl:text-3xl py-0 text-dsBlue font-bold font-Roboto'>Nombre de la compa&ntilde;ia del Cliente</div>
                            <div className=''>
                                <BreadCrumb className='bg-dsgray font-bold border-0 py-0 px-0 text-xs xl:text-base' model={items} home={home} />   
                            </div>
                        </div>
                        <div className='w-4/12  flex flex-col space-y-1'>
                            <div className='text-dsBlue font-bold text-sm xl:text-lg truncate w-full text-right'>Juan Perez Martinez</div>
                            <div className='w-full '>
                                <Link className='flex items-center text-[10px] xl:text-sm text-red-700 font-bold ds-link-default text-right justify-end ' to={'/'}>
                                    <i className="material-icons-outlined md-18">logout</i>
                                    Cerrar Sesi&oacute;n
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className='flex-auto px-4 lg:px-8'>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                        <p>Temp</p>
                    </div>
                    <div className=' lg:min-h-[25px] px-4 text-dsGray font-bold flex flex-col lg:flex-row lg:justify-between space-y-0 py-2 lg:py-0 justify-center text-center'>
                        <p className='m-0'>{new Date().getFullYear()} &copy; Racol Computers S.R.L.</p>
                        <p>Desarrollado Por Brian Almengo</p>
                    </div>
                </div>
            </div>
            <div className="card flex justify-content-center">
                <Sidebar className='bg-gray-default p-sidebar-header-teamsidemenu w-4/5 sm:w-1/4' 
                    visible={visible} onHide={() => setVisible(false)}
                    icons = { customIcons }
                    style={ { backgroundColor: '#282c34' } }
                    content={({ closeIconRef, hide }) => (

                    <section className='flex flex-col text-white' >
                        <div className='bg-dsgray user-home-navbar-effects min-h-[56px] xl:min-h-[75px] xl:max-h-[75px]'>
                            <div className='' style={{ textDecoration: 'none' }}>
                                <a href={'/'} className='contents w-fit' style={{ textDecoration: 'none' }}>
                                    <div className='self-center pt-2 text-4xl py-0 font-bold text-dsBlue font-Roboto text-center flex items-center justify-center'>
                                        <img src="assets/img/logoIcono.png" style={{ height: '32px', width: 'auto' }} alt="" />
                                        <p className='p-0 m-0 uppercase'>Autoneg</p> 
                                        <span className='font-Roboto self-end text-red-700 text-sm'>&nbsp;3.0</span>
                                    </div>
                                </a>
                                <div className='self-center text-xl py-0 font-bold text-green-800 font-Roboto text-center mb-2'>Facturacion <span className='text-text-green-800'>Electronica</span></div>
                            </div>
                        </div>
                        <div className='px-6'>
                            {/* grupo */}
                            <div className='font-bold mb-0 mt-4 flex items-center text-base 2xl:text-base'>
                                Comprobantes
                            </div>
                            <div>
                                <ul className='mt-2 pl-0 space-y-3' style={{textDecoration: 'none', listStyle: 'none'}}>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">dashboard</i>&nbsp; Resumen</li>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">call_made</i>&nbsp; Emitidos</li>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">call_received</i> &nbsp; Recibidos</li>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">check</i> &nbsp; Aprobacion</li>
                                </ul>
                            </div>
                        </div>
                        <div className='px-6'>
                            {/* grupo */}
                            <div className='font-bold mb-0 flex items-center text-base 2xl:text-base mt-2'>
                                Clientes
                            </div>
                            <div>
                                <ul className='mt-2 pl-0 space-y-2' style={{textDecoration: 'none', listStyle: 'none'}}>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">list</i>&nbsp; Listado</li>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">verified_user</i>&nbsp; Authorizar Rutas</li>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">forward_to_inbox</i>&nbsp; Enviar Uso</li>
                                </ul>
                            </div>
                        </div>
                        <div className='px-6'>
                            {/* grupo */}
                            <div className='font-bold mb-0 flex items-center text-base 2xl:text-base mt-2'>
                                Usuario
                            </div>
                            <div>
                                <ul className='mt-2 pl-0 space-y-2' style={{textDecoration: 'none', listStyle: 'none'}}>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">person</i>&nbsp; Perfil</li>
                                    <li className='flex items-center text-base 2xl:text-base'><i className="material-icons-outlined md-18 ">manage_accounts</i>&nbsp; Configuracion</li>
                                </ul>
                            </div>
                        </div>
                        {/* footer */}
                        <div className=' absolute bottom-0 w-full text-[#d0d0d0] pt-2 pb-6'>
                            <div className="flex flex-col align-items-center gap-2 items-center">
                                {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" /> */}
                                <span className="font-bold">Amy Elsner</span>
                                <span className="font-bold text-red-500 items-center flex"><i className="material-icons-outlined md-18">logout</i>&nbsp;Cerrar Sesi&oacute;n</span>
                            </div>
                        </div>
                    </section>
                    )}>
                </Sidebar>                    
            </div>
        </div>
    );
}

export default AdminHome;